module.exports = (__webpack_require__(14))(86);


//////////////////
// WEBPACK FOOTER
// delegated ../../third-party-assemblies/Infragistics/IgniteUI/16.2.20162.2040/js/modules/infragistics.ui.grid.shared.js from dll-reference obpa_dependencies
// module id = 418
// module chunks = 0